import React from 'react';
import Plot from 'react-plotly.js';

/**
 * ChartDisplay Component
 * Renders Plotly charts from agent tool results
 * ✅ Memoized to prevent re-renders when chart data unchanged
 */
function ChartDisplay({ chartData, chartType }) {
    if (!chartData) {
        return null;
    }

    try {
        // Handle different data formats
        let plotlyData = chartData;

        // If wrapped in chart_data property, unwrap it
        if (chartData.chart_data) {
            plotlyData = chartData.chart_data;
        }

        // Plotly data should have 'data' and 'layout' properties
        if (!plotlyData.data && !Array.isArray(plotlyData)) {
            return null;
        }

        return (
            <div className="chart-display">
                <div className="chart-header">
                    <span className="chart-icon">📈</span>
                    <span className="chart-label">Visualization</span>
                </div>
                <div className="chart-wrapper">
                    <Plot
                        data={plotlyData.data || plotlyData}
                        layout={{
                            ...(plotlyData.layout || {}),
                            autosize: true,
                            margin: { l: 60, r: 40, t: 60, b: 60 },
                            font: { family: 'system-ui, -apple-system, sans-serif' }
                        }}
                        config={{
                            responsive: true,
                            displayModeBar: true,
                            displaylogo: false,
                            modeBarButtonsToRemove: ['lasso2d', 'select2d']
                        }}
                        style={{ width: '100%', height: '500px' }}
                        useResizeHandler={true}
                    />
                </div>
            </div>
        );
    } catch (error) {
        console.error('Chart rendering error:', error);
        return (
            <div className="chart-display chart-error">
                <p>⚠️ Error rendering chart. Check console for details.</p>
            </div>
        );
    }
}

// ✅ Memoize component: Only re-render when chartData or chartType changes
export default React.memo(ChartDisplay, (prevProps, nextProps) => {
    // Custom comparison: Deep check if chart data actually changed
    return JSON.stringify(prevProps.chartData) === JSON.stringify(nextProps.chartData) && prevProps.chartType === nextProps.chartType;
});
